

<div *ngIf="!loggingIn" class="flex flex-col sm:justify-start sm:items-center gap-4">
  <!-- AAD Login options -->
  <div class="flex flex-col md:flex-row gap-6 sm:gap-40">
    <div class="flex flex-col justify-center items-center gap-8 p-t-32">
      <div class="flex flex-col md:flex-row max-md:justify-center max-md:items-center gap-2">
       <span style="font-family: Oswald; font-size: 30pt;">Administration Portal</span>
      </div>
     <button mat-button (click)="login()" color="primary">
       <span class="f-s-20 p-32">Enter</span>
     </button>
  </div>
</div>

<div *ngIf="loggingIn">
  <div id="globalLoader" class="global-loader">
    <h1>Loading...</h1>
  </div>
</div>

